// packages/viewport/src/with-viewport-match.js
import {
  createHigherOrderComponent,
  pure,
  useViewportMatch
} from "@wordpress/compose";
import { jsx } from "react/jsx-runtime";
var withViewportMatch = (queries) => {
  const queryEntries = Object.entries(queries);
  const useViewPortQueriesResult = () => Object.fromEntries(
    queryEntries.map(([key, query]) => {
      let [operator, breakpointName] = query.split(" ");
      if (breakpointName === void 0) {
        breakpointName = operator;
        operator = ">=";
      }
      return [key, useViewportMatch(breakpointName, operator)];
    })
  );
  return createHigherOrderComponent((WrappedComponent) => {
    return pure((props) => {
      const queriesResult = useViewPortQueriesResult();
      return /* @__PURE__ */ jsx(WrappedComponent, { ...props, ...queriesResult });
    });
  }, "withViewportMatch");
};
var with_viewport_match_default = withViewportMatch;
export {
  with_viewport_match_default as default
};
//# sourceMappingURL=with-viewport-match.mjs.map
